// extracted by mini-css-extract-plugin
module.exports = {"btnWrap":"StatementDocument_btnWrap_YU9oU"};